<template>
  <b-container class="container-field">
    <b-row>
      <!-- <div>{{ items }}</div> -->
        <b-table-simple>
          <b-thead>
            <b-tr>
              <b-th v-for="field in tableFieldsCampos" :key="field.key">
                {{ field.label }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="row in fillActiveList">
              <!-- {{ row }} -->
              <b-tr :key="row.id">
                <b-td>
                  {{ row.item.sequenceNumber }}
                  <!-- /{{row.item.id}} -->
                </b-td>
                <b-td>
                  <b-form-input
                    class="input-name"
                    type="text"
                    v-model="row.item.fieldName"
                    required
                  />
                </b-td>
                <b-td>
                  <b-form-select
                    :options="optionsCustomField"
                    v-model="row.item.customField"
                  >
                  </b-form-select>
                </b-td>
                <b-td>
                  <b-form-select
                    class="select-boolean"
                    :options="optionsBoolean"
                    v-model="row.item.required"
                  ></b-form-select>
                </b-td>
                <b-td>
                  <b-form-input
                    class="input-tip"
                    type="text"
                    v-model="row.item.tip"
                  ></b-form-input>
                </b-td>
                <b-td style="min-width: 200px">
                  <!-- {{row.item}} -->
                  <table-form-resequence
                    class="d-inline"
                    :item="row.item"
                    :items="items"
                    :display-name="row.item.fieldName"
                  ></table-form-resequence>
                  <b-button class="ml-1" size="sm" @click="deleteField(row)">
                    X
                  </b-button>
                </b-td>
              </b-tr>
            </template>
          </b-tbody>
        </b-table-simple>
        <b-button size="sm" @click="addFields">Adicionar campo</b-button>
    </b-row>
  </b-container>
</template>
<script>
import CustomSequenceOccurrenceControl from "./CustomSequenceOccurrenceControl";
export default {
  name: "OccurrenceCustomFields",
  props: {
    items: Array,
    modelstate: Object,
  },
  components: {
    TableFormResequence: () =>
      import("./TableResequenceOccurrenceCustomFields.vue"),
  },
  mixins: [CustomSequenceOccurrenceControl],
  data() {
    return {
      tableRows: [],
      optionsCustomField: [
        { value: 0, text: "Texto Simples" },
        { value: 1, text: "Texto Composto" },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFieldsCampos: [
        {
          label: "Id",
          key: "sequenceNumber",
          sortable: false,
        },
        {
          label: "Nome",
          key: "fieldName",
          sortable: false,
        },
        {
          label: "Tipo",
          key: "type",
          sortable: false,
        },
        {
          label: "Obrigatório",
          key: "required",
          sortable: false,
        },
        {
          label: "Dica",
          key: "tip",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  mounted: function () {
    // console.log("ok");
    this.loadTableRows();
  },
  computed: {
    fillActiveList() {
      let camposAtivos = [];
      for (let campo of this.tableRows.sort(
        (c1, c2) => c1.item.sequenciaExibicao - c2.item.sequenciaExibicao
      )) {
        //console.log("campo:", campo);
        if (campo.item.active) {
          camposAtivos.push(campo);
        }
      }
      return camposAtivos;
    },
  },
  methods: {
    addTableRow(item) {
      // console.log(item);
      this.tableRows.push({
        detailsShowing: false,
        item: item,
      });
    },
    addFields() {
      let item = {
        active: true,
        sequenceNumber: this.getNextSequenceNumber(this.items),
        required: false,
        fieldName: "",
        defaultValue: "",
        tip: "",
      };

      this.items.push(item);
      this.addTableRow(item);
      this.$forceUpdate();
    },
    deleteField(row) {
      console.log(row);
      if (!row.item.id || row.item.id == 0) {
        let rowIndex = this.tableRows.indexOf(row);
        if (rowIndex >= 0) {
          this.tableRows.splice(rowIndex, 1);
        }
        let itemIndex = this.items.indexOf(row.item);
        // console.log(itemIndex)
        if (itemIndex >= 0) {
          this.items.splice(itemIndex, 1);
        }
      } else {
        row.item.active = false;
      }
      let campos = this.fillActiveList;
      for (let i = 0; i < campos.length; i++) {
        campos[i].item.sequenceNumber = i + 1;
      }
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.items) {
        if (this.items.length > 0) {
          this.items.forEach((item) => {
            this.addTableRow(item);
          });
        }
      }
      this.$forceUpdate();
    },
    updateFieldsSequencyUp(campo) {
      this.updateIdWhenItGoesUp(this.items, campo);
    },
    updateFieldsSequenceDown(campo) {
      this.updateWhenGoDown(this.items, campo);
    },
  },
  watch: {
    items() {
      this.loadTableRows();
    },
  },
};
</script>
